module.exports = __webpack_public_path__ + "img/xin.2b0ce162.png";